export default "__VITE_ASSET__ea692d75__"